import React from 'react';
import { useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import FnbService from '../ApiServices/FnbService';
import { useState } from 'react';
import { Container, Row, Col, Table, Card } from 'react-bootstrap';
import '../assets/css/FnbOrderCode.css';
import CheckIcon from './CheckIcon';
import moment from 'moment';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useDispatch } from 'react-redux';
import { BASEURL } from '../config';
import { printTicket as printTicketAction } from '@store/booking/bookingActions';
import { getPrintTicket } from '../store/booking/bookingActions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { currFormat } from '../helper/utils';
const orders = {
  orderCode: 'ORD123456',
  orderTime: '2025-08-11T10:45:00Z',
  tableNumber: 'T5',
  qrValue: 'https://restaurant.com/order/ORD123456',
  items: [
    { name: 'Burger', qty: 2, price: 5.99 },
    { name: 'Fries', qty: 1, price: 2.99 },
    { name: 'Coke', qty: 3, price: 1.5 },
  ],
};

function PrintTicketComponent({ ticketHTML }) {
  return (
    <div
      style={{ backgroundColor: 'white ' }}
      dangerouslySetInnerHTML={{ __html: ticketHTML ? ticketHTML : '' }}
    ></div>
  );
}

function FnbOrderFinalTicket() {
  const params = useParams();
  const ticketReceiptRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const [orderDetails, setOrderDetails] = useState([]);
  const [ticketHTML, setTicketHTML] = useState(null);
  const [showTicket, setShowTicket] = useState(false);

  const initPrintTicketReceipt = useReactToPrint({
    content: () => ticketReceiptRef.current,
    copyStyles: true, // re-use current styles
    onAfterPrint: () => setShowTicket(false), // hide after print
    onPrintCancel: () => setShowTicket(false),
  });

  const handleTicketPrint = async (orderData) => {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf(' electron/') > -1) {
      dispatch(
        printTicketAction({
          ft_id: orderData.ft_id,
          cinema_id: orderData.cinema_id,
          showBookingId: 0,
          baseurl: BASEURL,
        }),
      );
    } else {
      setShowTicket(true);
      const ticket_HTML = await dispatch(
        getPrintTicket(
          { booking_id: null, cinema_id: orderData.cinema_id },
          {
            ft_id: orderData.ft_id,
            sb_id: 0,
            cinema_id: orderData.cinema_id,
          },
        ),
      );
      setTicketHTML(ticket_HTML);
      initPrintTicketReceipt();
    }
  };

  useEffect(() => {
    const fetchFnbOrderDetails = async (ft_id = null) => {
      if (!ft_id) {
        return toast.error('Order Id is missing');
      }

      try {
        const response = await FnbService.GetOnlyFnbOrderDetails({ ft_id });

        const { data } = response || {};

        if (!data.status || !data.Records2 || !data.Records2.length) {
          return toast.error('Fnb Data not found');
        }

        setOrderDetails([...data.Records2]);

        setTimeout(() => {
          handleTicketPrint({
            ft_id: data.Records2[0].order_code,
            cinema_id: data.Records2[0].cinema_id,
          }).then();
        }, 2000);
      } catch (error) {
        console.log(error);
      }
    };

    if (!params.orderId) {
      return <>No order found</>;
    }

    fetchFnbOrderDetails(params.orderId).then(() => {
      setTimeout(() => {
        history.replace('/book-show');
      }, 15000);
    });
  }, []);

  return (
    <>
      {showTicket && (
        <div ref={ticketReceiptRef} className="receipt-container">
          <PrintTicketComponent ticketHTML={ticketHTML} />
        </div>
      )}
      {orderDetails.length ? (
        <div className="kiosk-wrapper">
          <div>
            <Row className="mb-4 align-items-center">
              <Col md={12}>
                <div className="flex items-center flex-row justify-center text-center">
                  <CheckIcon />
                  <span className="mx-2">Order placed successfully</span>
                </div>
              </Col>
            </Row>

            <Table bordered responsive className="kiosk-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Name</th>
                  <th>Qty</th>
                  {/* <th>Unit</th> */}
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails.map((item, index) => (
                  <tr key={item.fst_id}>
                    <td className="px-2 py-1">{index + 1}</td>
                    <td className="px-2 py-1">{item.fst_item_name}</td>
                    <td className="text-right px-2 py-1">{item.fst_quantity}</td>
                    {/* <td>{item.price.toFixed(2)}</td> */}
                    <td className="text-right px-2 py-1">
                      {currFormat(item.fp_total_amount || 0)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="3" className="text-right px-2 py-1">
                    <strong>Grand Total:</strong>
                  </td>
                  <td className="text-right px-2 py-1">
                    <strong>
                      {currFormat(orderDetails[0].ft_total_amount || 0)}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="d-flex justify-content-between items-center flex-row fnb-order-meta-data-container">
              <div>
                <p className="text-white">
                  <span className="fnb-order-label">Cinema Name:</span>{' '}
                  <span className="fnb-order-meta-value">
                    {orderDetails[0].ft_cinema_name}
                  </span>
                </p>
                <p className="text-white">
                  <span className="fnb-order-label">Order Time:</span>{' '}
                  <span className="fnb-order-meta-value">
                    {moment(orderDetails[0].ft_date_time).format(
                      'DD MMMM YYYY hh:mm A',
                    )}
                  </span>
                </p>
                <p className="text-white">
                  <span className="fnb-order-label">Order Code:</span>{' '}
                  <span className="fnb-order-meta-value">
                    {orderDetails[0].order_code}
                  </span>
                </p>
                <p className="text-white">
                  <span className="fnb-order-label">Pick Up Code:</span>{' '}
                  <span className="fnb-order-meta-value">
                    {orderDetails[0].pickup_code}
                  </span>
                </p>
              </div>
              <div>
                <img src={orderDetails[0].qrcode} alt="" height={100} width={100} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="mt-5 d-flex justify-content-center">
        <Col lg={4} className="d-flex justify-content-center align-items-center">
          <span
            className="ls-3 kumbh fw-bold px-4 blue-btn"
            onClick={(e) => history.push('/book-show')}
          >
            Home
          </span>
        </Col>
        <Col lg={4} className="d-flex justify-content-center align-items-center">
          <span
            className="ls-3 kumbh fw-bold px-4 blue-btn"
            onClick={(e) =>
              handleTicketPrint({
                ft_id: orderDetails[0].order_code,
                cinema_id: orderDetails[0].cinema_id,
              })
            }
          >
            Print
          </span>
        </Col>
      </div>
    </>
  );
}
export default withNamespaces()(FnbOrderFinalTicket);
